$shm_hitalama_dragtree_drag $rise_drag
	hold_delay 0
	hold_move_threshold 10
